const initialState = {
  venue: null,
  venueLookupFailed: false,
  userWon: false,
  prize: null,
  joke: null,
};

export default initialState;
